module.exports = __webpack_public_path__ + "static/img/4.770d469.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/4.png
// module id = FbgQ
// module chunks = 0